import type { FaireProductEntity } from "../../entity_types/product";

export const p_wheh6hhghd: FaireProductEntity = {
  token: "p_wheh6hhghd",
  type: "product",
  name: "20-25pc Charoite Crystal Tumbled Stones, XS",
  brandToken: "b_rt8fmuccyw",
  brandName: "Caspar Curiosities",
  imageUrl:
    "https://cdn.faire.com/fastly/40914220ca3513cac75f2c80790b86349592c1d185d8f93bccb469a6e4e77bb4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b615e6ab624a2086c555a8138a7969e16298318e7ce2dca403ce3c0246e0268.jpeg",
    "https://cdn.faire.com/fastly/161aabfe7498455faeb7df65ffbb65c8a18922eecf5d56c7642d0f4e816dd27f.jpeg",
    "https://cdn.faire.com/fastly/b8c32c4f6def7d14c9da301c49fc1bf3af61f29e6f211ddab385b4363942df36.jpeg",
    "https://cdn.faire.com/fastly/c4b048ff53246d23762e9d88c7787c5760ba4880fb763b9fb875d8ff2349f91a.jpeg",
    "https://cdn.faire.com/fastly/af982d83b9e46fc731f1da2e5dc468f663fb2d65c4c19b1d2d3376975dc2f362.jpeg",
    "https://cdn.faire.com/fastly/bf72bd22c3e26b32cf56bda6c7322ac8eb34cc6e6b9576f06e1174e25153b013.jpeg",
    "https://cdn.faire.com/fastly/ecf3047e100a747533a6c6eb889c55af0e35a2eb6de91ae5848ecd3717c9f366.jpeg",
    "https://cdn.faire.com/fastly/0d26135786ad5d3f3e1dff42c657fec4d7036a0c196fd947fb165122bb87cf64.jpeg",
  ],
  priceDollars: 6,
  description:
    "For your consideration are these super flashy genuine Charoite crystal tumbled stones. They measure .25 to .65 inches and are perfect for crystal grids or wire wrapping.\n\nThese small tumbled Charoite crystals are sold in 20 gram lots that contains approximately 20-25 pieces. \n\n\n\n",
  tags: [],
  msrpDollars: 12,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:40.707Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
